import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSupportLeg = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 25,
	height: 100,
	viewBox: "0 0 25.0 100.0",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M 0.0 0.0 L 0.0 100.0 L 25.0 100.0 L 25.0 0.0",
		fill: "none",
		stroke: "currentColor",
		strokeWidth: 1
	})
});
export default SvgSupportLeg;
